import { Component, Inject } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { DownloadService } from '../crud-service';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { MediaObserver } from '@angular/flex-layout';
import { TypeIndexEnum } from 'src/app/domain/registration/enums/type-index.enum';
import { DownloadCrudIndex } from './crud-index';
import { Router } from '@angular/router';
import { ChangeDetectorRef } from '@angular/core';
import { AuthService } from 'src/app/views/auth/shared/auth.service';
import { PermissionService } from 'src/app/shared/permission.service';


@Component({
  selector: 'app-product-category-select-index',
  templateUrl: './crud-index-select.component.html',
  styleUrls: ['./crud-index.component.sass'],
  providers: [DownloadService],
})
export class DownloadIndexSelectComponent extends DownloadCrudIndex {
openDetails(_t16: any) {
throw new Error('Method not implemented.');
}
  override title: string = 'SELECIONE UM PLANO';
  constructor(
    override dialog: MatDialog,
    override service: DownloadService,
    override toastService: ToastService,
    override mediaObserver: MediaObserver,
    public dialogRefSelect: MatDialogRef<DownloadIndexSelectComponent>,
    override permissionService: PermissionService,
    @Inject(MAT_DIALOG_DATA)
    data: {
      type: TypeIndexEnum;
      select: boolean;
    },
    override router: Router,
    protected override cdr: ChangeDetectorRef,
    protected override authService: AuthService 
  ) {
    super(dialog, service, toastService, mediaObserver, router, cdr,authService, permissionService);
    this.dataSelect = data;
  }

  ngOnInit(): void {}

  onCancel() {
    this.dialogRefSelect.close();
  }

  onSelect(data: any) {
    this.dialogRefSelect.close(data?.row);
  }
}
